/**
 * 361 Sleep — About Us carousels (hero + peek layouts v3)
 * Also upgrades legacy #howWeStarted static card → peek slider when Liquid lags.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function whenSwiper(fn) {
    if (window.Swiper) {
      fn(window.Swiper);
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (window.Swiper) {
        clearInterval(timer);
        fn(window.Swiper);
      } else if (tries > 80) {
        clearInterval(timer);
      }
    }, 50);
  }

  function assetUrlFromSibling(filename) {
    var probe =
      document.querySelector('#howWeStarted img[src*="/assets/"]') ||
      document.querySelector('.about361 img[src*="/assets/"]') ||
      document.querySelector('link[href*="/assets/361-about.css"]') ||
      document.querySelector('link[href*="/assets/361-sleep.css"]');

    var src = '';
    if (probe) {
      src = probe.getAttribute('src') || probe.getAttribute('href') || '';
    }
    if (!src) return filename;

    var next = src.replace(/\/assets\/[^/?#]+/, '/assets/' + filename);
    if (/[?&]v=/.test(next)) {
      next = next.replace(/([?&]v=)[^&]*/, '$1' + Date.now());
    } else {
      next += (next.indexOf('?') === -1 ? '?' : '&') + 'v=' + Date.now();
    }
    return next;
  }

  function buildPeekSlide(imageFile, alt, caption, eager) {
    var imgSrc = assetUrlFromSibling(imageFile);
    return (
      '<article class="swiper-slide about361-peek__slide">' +
      '<div class="about361-peek__media">' +
      '<img src="' + imgSrc + '" width="1785" height="1310" alt="' + alt + '" loading="' + (eager ? 'eager' : 'lazy') + '" decoding="async">' +
      '</div>' +
      '<p class="about361-peek__caption">' + caption + '</p>' +
      '</article>'
    );
  }

  function howWeStartedPeekHTML() {
    return (
      '<div class="about361-peek__wrap">' +
      '<div class="swiper about361-peek__swiper" dir="ltr">' +
      '<div class="swiper-wrapper">' +
      buildPeekSlide(
        'about-how-slide-saudi-brand.png',
        'تشكيلة وسائد 361',
        '361 براند سعودي بالكامل.',
        true
      ) +
      buildPeekSlide(
        'about-how-slide-doctors.png',
        'إشراف أطباء مختصين',
        'بإشراف أطباء مختصين.',
        true
      ) +
      '</div></div></div>'
    );
  }

  function upgradeLegacyHowCard() {
    var section = document.getElementById('howWeStarted');
    if (!section) return false;

    var peek = section.querySelector('.about361-peek');
    if (peek) {
      var html = peek.innerHTML || '';
      var hasTwo =
        html.indexOf('about-how-slide-saudi-brand') !== -1 &&
        html.indexOf('about-how-slide-doctors') !== -1;
      var hasExtra =
        html.indexOf('about-how-slide-third') !== -1 ||
        html.indexOf('about-how-slide-fourth') !== -1 ||
        peek.querySelectorAll('.swiper-slide').length > 2;

      if (hasTwo && !hasExtra) {
        return false;
      }
      // Replace outdated peek slides (foam/cad/old pillows / extra 3rd+4th)
      if (peek._aboutSwiper) {
        try {
          peek._aboutSwiper.destroy(true, true);
        } catch (e) {}
        peek._aboutSwiper = null;
      }
      peek.innerHTML = howWeStartedPeekHTML();
      peek.setAttribute('data-about-carousel-section', '');
      peek.setAttribute('data-about-layout', 'peek');
      return true;
    }

    var card = section.querySelector('.about361__card');
    if (!card) return false;

    peek = document.createElement('div');
    peek.className = 'about361-peek';
    peek.setAttribute('data-about-carousel-section', '');
    peek.setAttribute('data-about-layout', 'peek');
    peek.innerHTML = howWeStartedPeekHTML();

    card.parentNode.insertBefore(peek, card);
    card.parentNode.removeChild(card);
    return true;
  }

  function initHeroCarousel(root, Swiper) {
    var el = root.querySelector('.about361-carousel__swiper');
    if (!el || el.swiper) return;

    var prev = root.querySelector('[data-about-prev]');
    var next = root.querySelector('[data-about-next]');

    root._aboutSwiper = new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 650,
      grabCursor: true,
      watchOverflow: true,
      resistanceRatio: 0.65,
      navigation: {
        prevEl: prev,
        nextEl: next
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'السابق',
        nextSlideMessage: 'التالي'
      }
    });
  }

  function initPeekCarousel(root, Swiper) {
    var el = root.querySelector('.about361-peek__swiper');
    if (!el || el.swiper) return;

    // Keep Swiper math LTR (rtl:true broke this carousel). For Arabic layout,
    // reverse the DOM so the first content slide sits on the right with the
    // next slide peeking on the left; start at the end, then slide toward left.
    el.setAttribute('dir', 'ltr');

    var wrapper = el.querySelector('.swiper-wrapper');
    var slides = wrapper ? Array.prototype.slice.call(wrapper.children) : [];
    if (wrapper && slides.length > 1 && !el.getAttribute('data-peek-start-right')) {
      for (var i = slides.length - 1; i >= 0; i -= 1) {
        wrapper.appendChild(slides[i]);
      }
      el.setAttribute('data-peek-start-right', '1');
    }

    var slideCount = el.querySelectorAll('.swiper-slide').length;

    root._aboutSwiper = new Swiper(el, {
      slidesPerView: 1.18,
      centeredSlides: true,
      initialSlide: Math.max(0, slideCount - 1),
      spaceBetween: 18,
      speed: 650,
      grabCursor: true,
      watchOverflow: true,
      resistanceRatio: 0.7,
      autoHeight: false,
      rtl: false,
      breakpoints: {
        750: {
          slidesPerView: 1.28,
          spaceBetween: 24
        },
        1100: {
          slidesPerView: 1.38,
          spaceBetween: 32
        }
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'السابق',
        nextSlideMessage: 'التالي'
      }
    });
  }

  function initDuoCarousel(root, Swiper) {
    var el = root.querySelector('.about361-carousel__swiper');
    if (!el || el.swiper) return;

    var prev = root.querySelector('[data-about-prev]');
    var next = root.querySelector('[data-about-next]');

    // Same RTL start as peek: first content sits on the right, next peeks/slides left.
    el.setAttribute('dir', 'ltr');
    var wrapper = el.querySelector('.swiper-wrapper');
    var slides = wrapper ? Array.prototype.slice.call(wrapper.children) : [];
    if (wrapper && slides.length > 1 && !el.getAttribute('data-duo-start-right')) {
      for (var i = slides.length - 1; i >= 0; i -= 1) {
        wrapper.appendChild(slides[i]);
      }
      el.setAttribute('data-duo-start-right', '1');
    }
    var slideCount = el.querySelectorAll('.swiper-slide').length;

    root._aboutSwiper = new Swiper(el, {
      slidesPerView: 1.15,
      spaceBetween: 14,
      speed: 650,
      grabCursor: true,
      watchOverflow: true,
      resistanceRatio: 0.7,
      initialSlide: Math.max(0, slideCount - 1),
      rtl: false,
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 22
        },
        1100: {
          slidesPerView: 2,
          spaceBetween: 28
        }
      },
      navigation: {
        prevEl: prev,
        nextEl: next
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'السابق',
        nextSlideMessage: 'التالي'
      }
    });
  }

  function initCarousel(root, Swiper) {
    var layout = root.getAttribute('data-about-layout');
    if (layout === 'peek') {
      initPeekCarousel(root, Swiper);
      return;
    }
    if (layout === 'duo' || root.classList.contains('about361-carousel--duo')) {
      initDuoCarousel(root, Swiper);
      return;
    }
    initHeroCarousel(root, Swiper);
  }

  function upgradePromisesBannerSingle() {
    var section =
      document.getElementById('aboutCarousel1') ||
      Array.prototype.find.call(document.querySelectorAll('.about361-carousel'), function (el) {
        return (el.textContent || '').indexOf('وجدنا الكثير من الوعود') !== -1;
      });
    if (!section) return false;

    var slides = section.querySelectorAll('.swiper-slide');
    if (slides.length > 1) {
      for (var i = 1; i < slides.length; i += 1) {
        slides[i].parentNode.removeChild(slides[i]);
      }
    }

    var nav = section.querySelector('.about361-carousel__nav');
    if (nav) nav.remove();

    section.setAttribute('data-about-static-banner', '1');
    var root = section.matches('[data-about-carousel-section]')
      ? section
      : section.querySelector('[data-about-carousel-section]');
    if (root) root.removeAttribute('data-about-carousel-section');

    return true;
  }

  function upgradeNoOneSolutionSingle() {
    var section =
      document.getElementById('aboutCarousel2') ||
      Array.prototype.find.call(document.querySelectorAll('.about361-carousel'), function (el) {
        return (el.textContent || '').indexOf('لا يوجد حل واحد يناسب الجميع') !== -1;
      });
    if (!section) return false;

    var slides = section.querySelectorAll('.swiper-slide');
    // Keep only the first banner; remove extras if Liquid still has multiple
    if (slides.length > 1) {
      for (var i = 1; i < slides.length; i += 1) {
        slides[i].parentNode.removeChild(slides[i]);
      }
    }

    var nav = section.querySelector('.about361-carousel__nav');
    if (nav) nav.remove();

    var img =
      section.querySelector('.swiper-slide img') ||
      section.querySelector('.about361-carousel__slide-media img');
    if (img && (img.getAttribute('src') || '').indexOf('about-no-one-solution.png') === -1) {
      img.setAttribute('src', assetUrlFromSibling('about-no-one-solution.png'));
      img.setAttribute('alt', 'لا يوجد حل واحد يناسب الجميع');
      img.removeAttribute('srcset');
    }

    var swiperEl = section.querySelector('.about361-carousel__swiper');
    if (swiperEl) {
      section.setAttribute('data-about-static-banner', '1');
      var root = section.matches('[data-about-carousel-section]')
        ? section
        : section.querySelector('[data-about-carousel-section]');
      if (root) root.removeAttribute('data-about-carousel-section');
    }

    return true;
  }

  function upgradeNoOneSolutionBand() {
    var sections = [];
    ['aboutCarousel2', 'aboutCarousel2b'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) sections.push(el);
    });

    document.querySelectorAll('.about361-carousel').forEach(function (el) {
      var t = el.textContent || '';
      if (
        t.indexOf('لا يوجد حل واحد') !== -1 ||
        t.indexOf('هكذا خرجت أولى منتجاتنا') !== -1
      ) {
        if (sections.indexOf(el) === -1) sections.push(el);
      }
    });

    sections.forEach(function (section) {
      section.classList.add('about361-carousel--band');
      var heading = section.querySelector('.about361__title, .about361-carousel__heading, h2, p.about361-carousel__heading');
      if (heading) {
        heading.classList.add('about361-carousel__heading');
        if (heading.tagName === 'H2' || heading.tagName === 'H1' || heading.tagName === 'H3') {
          var p = document.createElement('p');
          p.className = heading.className;
          p.innerHTML = heading.innerHTML;
          Array.prototype.forEach.call(heading.attributes, function (attr) {
            if (attr.name !== 'class') p.setAttribute(attr.name, attr.value);
          });
          heading.parentNode.replaceChild(p, heading);
        }
      }

      // هكذا خرجت — PSD = 2 slides; strip extras + force design assets if Liquid lags
      if ((section.textContent || '').indexOf('هكذا خرجت أولى منتجاتنا') !== -1) {
        var slides = section.querySelectorAll('.swiper-slide');
        if (slides.length > 2) {
          for (var i = slides.length - 1; i >= 2; i -= 1) {
            slides[i].parentNode.removeChild(slides[i]);
          }
        }
        var slideImgs = section.querySelectorAll('.swiper-slide img, .about361-carousel__slide-media img');
        var expected = [
          { file: 'about-first-products-slide-1.png', alt: 'هكذا خرجت أولى منتجاتنا' },
          { file: 'about-first-products-slide-2.png', alt: 'هكذا خرجت أولى منتجاتنا — الشريحة الثانية' }
        ];
        expected.forEach(function (item, idx) {
          var img = slideImgs[idx];
          if (!img) return;
          if ((img.getAttribute('src') || '').indexOf(item.file) === -1) {
            img.setAttribute('src', assetUrlFromSibling(item.file));
            img.setAttribute('alt', item.alt);
          }
        });
      }
    });
  }

  function upgradeJourneyPanelImage() {
    var section = document.getElementById('ourJourney');
    if (!section) {
      section = Array.prototype.find.call(document.querySelectorAll('.about-chapter'), function (el) {
        return (el.textContent || '').indexOf('رحلتنا ما زالت في بدايتها') !== -1;
      });
    }
    if (!section) return false;

    var changed = false;

    var icon = section.querySelector('.about361__icon-img');
    var iconWrap = section.querySelector('.about361__icon-wrap');
    if (icon && (icon.getAttribute('src') || '').indexOf('about-journey-beginning-icon.png') === -1) {
      icon.setAttribute('src', assetUrlFromSibling('about-journey-beginning-icon.png'));
      changed = true;
    } else if (iconWrap && !icon) {
      iconWrap.innerHTML =
        '<img class="about361__icon-img" src="' +
        assetUrlFromSibling('about-journey-beginning-icon.png') +
        '" width="218" height="219" alt="" loading="lazy" decoding="async">';
      changed = true;
    }

    var img =
      section.querySelector('.about361-pair__single-media img') ||
      section.querySelector('.about361__feature-media img');
    if (img && (img.getAttribute('src') || '').indexOf('about-first-products-slide-2.png') === -1) {
      img.setAttribute('src', assetUrlFromSibling('about-first-products-slide-2.png'));
      img.setAttribute('alt', 'وسادة 361 على منصة عرض — لأن كل بداية تحمل فرصة لصناعة راحة أفضل');
      changed = true;
    }

    return changed;
  }

  function upgradeComfortToPair() {
    var section =
      document.getElementById('aboutPairComfort') ||
      document.getElementById('aboutCarouselComfort') ||
      Array.prototype.find.call(document.querySelectorAll('.about361-carousel, .about-pair'), function (el) {
        return (el.textContent || '').indexOf('الراحة الحقيقية تبدأ بفهم طريقة نوم الجسم') !== -1;
      });

    if (!section) return false;

    if (
      section.classList.contains('about-pair') &&
      (section.innerHTML || '').indexOf('about-comfort-pair-1') !== -1 &&
      (section.innerHTML || '').indexOf('about-comfort-pair-2') !== -1
    ) {
      return false;
    }

    var img1 = assetUrlFromSibling('about-comfort-pair-1.png');
    var img2 = assetUrlFromSibling('about-comfort-pair-2.png');

    section.id = 'aboutPairComfort';
    section.className = 'about361 about-pair about-pair--band';
    section.removeAttribute('data-about-carousel-section');
    section.removeAttribute('data-about-layout');
    if (section._aboutSwiper) {
      try {
        section._aboutSwiper.destroy(true, true);
      } catch (e) {}
      section._aboutSwiper = null;
    }

    section.innerHTML =
      '<div class="page361 about361-pair__shell">' +
      '<p class="about361-pair__title">الراحة الحقيقية تبدأ بفهم طريقة نوم الجسم.</p>' +
      '<div class="about361-pair__grid">' +
      '<article class="about361-pair__card">' +
      '<div class="about361-pair__card-media">' +
      '<img src="' + img1 + '" width="1047" height="833" alt="وضعية نوم صحيحة مع دعم الرقبة على وسادة 361" loading="lazy" decoding="async">' +
      '</div></article>' +
      '<article class="about361-pair__card">' +
      '<div class="about361-pair__card-media">' +
      '<img src="' + img2 + '" width="844" height="844" alt="توضيح دعم فقرات الرقبة أثناء النوم" loading="lazy" decoding="async">' +
      '</div></article>' +
      '</div></div>';

    return true;
  }

  function upgradeNeedPairImages() {
    var section =
      document.getElementById('aboutPairNeed') ||
      Array.prototype.find.call(document.querySelectorAll('.about-pair, .about361'), function (el) {
        return (
          (el.textContent || '').indexOf('نسأل أنفسنا دائمًا') !== -1 ||
          (el.innerHTML || '').indexOf('about-need-pillow') !== -1 ||
          (el.innerHTML || '').indexOf('about-need-prototype') !== -1 ||
          (el.innerHTML || '').indexOf('about-need-slide') !== -1
        );
      });

    if (!section) return false;

    var imgs = section.querySelectorAll(
      '.about361-pair__card-media img, .about361-pair__grid img, .about361-pair__card img, img'
    );
    // Prefer only the two card images if many imgs exist
    var cardImgs = section.querySelectorAll('.about361-pair__card-media img, .about361-pair__card img');
    if (cardImgs.length >= 2) imgs = cardImgs;

    var expected = [
      { file: 'about-need-slide-1.png', alt: 'نسأل أنفسنا دائمًا عن احتياجات النوم' },
      { file: 'about-need-slide-2.png', alt: 'احتياج لم نلبّه بعد — تفاصيل المنتج' }
    ];
    var changed = false;
    expected.forEach(function (item, idx) {
      var img = imgs[idx];
      if (!img) return;
      var src = img.getAttribute('src') || '';
      if (src.indexOf(item.file) === -1 || src.indexOf('about-need-pillow') !== -1 || src.indexOf('about-need-prototype') !== -1) {
        img.setAttribute('src', assetUrlFromSibling(item.file));
        img.setAttribute('alt', item.alt);
        img.removeAttribute('srcset');
        changed = true;
      }
    });
    return changed;
  }

  function upgradeInsetPairPanel() {
    var section = document.getElementById('aboutPair2');
    if (!section) {
      section = Array.prototype.find.call(document.querySelectorAll('.about-pair'), function (el) {
        return (el.textContent || '').indexOf('ليس الهدف أن نصنع وسادة') !== -1;
      });
    }
    if (!section) return;
    section.classList.remove('about-pair--band');
    section.classList.add('about-pair--inset');
    var shell = section.querySelector('.about361-pair__shell');
    if (shell) shell.classList.add('about361-pair__shell--inset');
    var title = section.querySelector('.about361-pair__title');
    if (title && title.tagName === 'H2') {
      var p = document.createElement('p');
      p.className = title.className;
      p.innerHTML = title.innerHTML;
      Array.prototype.forEach.call(title.attributes, function (attr) {
        if (attr.name !== 'class') p.setAttribute(attr.name, attr.value);
      });
      title.parentNode.replaceChild(p, title);
    }

    // Same two images as ومن هذا الفارق
    var imgs = section.querySelectorAll('.about361-pair__card-media img');
    var expected = [
      { file: 'about-pair-diff-1.jpg', alt: 'وسادة طبية هلامية بتبريد الجل' },
      { file: 'about-pair-diff-2.png', alt: 'وسادة الذاكرة لتقويم انحناء الرقبة' }
    ];
    expected.forEach(function (item, idx) {
      var img = imgs[idx];
      if (!img) return;
      if ((img.getAttribute('src') || '').indexOf(item.file) === -1) {
        img.setAttribute('src', assetUrlFromSibling(item.file));
        img.setAttribute('alt', item.alt);
      }
    });
  }

  function upgradeTrustPeek() {
    var journey = document.getElementById('ourJourney');
    var section =
      document.getElementById('trustByTesting') ||
      Array.prototype.find.call(document.querySelectorAll('.about-chapter, .about-chapter--peek-only, .about361-peek'), function (el) {
        return (
          (el.textContent || '').indexOf('لأن الثقة تُبنى بالاختبار') !== -1 ||
          (el.innerHTML || '').indexOf('about-testing-foam') !== -1 ||
          (el.innerHTML || '').indexOf('about-trust-testing') !== -1
        );
      });

    // Prefer the section wrapper, not the inner peek node
    if (section && section.classList.contains('about361-peek')) {
      section = section.closest('.about-chapter, .about361') || section.parentElement;
    }

    var peekHtml =
      '<div class="about361-peek__wrap">' +
      '<div class="swiper about361-peek__swiper" dir="ltr">' +
      '<div class="swiper-wrapper">' +
      buildPeekSlide(
        'about-trust-testing.png',
        'اختبار المنتجات قبل الوعد بالراحة',
        'لأن الثقة تُبنى بالاختبار... لا بالوعود.',
        true
      ) +
      buildPeekSlide(
        'about-smallest-details.png',
        'تفاصيل تصميم مدروسة في كل منتج',
        'حتى أصغر التفاصيل... لها سبب.',
        false
      ) +
      '</div></div></div>';

    if (!section) {
      if (!journey || !journey.parentNode) return false;
      section = document.createElement('section');
      section.id = 'trustByTesting';
      section.className = 'about361 about-chapter about-chapter--peek-only about361--tight-top about361--tight-bottom';
      section.setAttribute('aria-label', 'الثقة بالاختبار');
      var peek = document.createElement('div');
      peek.className = 'about361-peek';
      peek.setAttribute('data-about-carousel-section', '');
      peek.setAttribute('data-about-layout', 'peek');
      peek.innerHTML = peekHtml;
      section.appendChild(peek);
      journey.parentNode.insertBefore(section, journey);
      return true;
    }

    var existing = section.querySelector('.about361-peek') || (section.classList.contains('about361-peek') ? section : null);
    if (existing && (existing.innerHTML || '').indexOf('about-trust-testing') !== -1 && (existing.innerHTML || '').indexOf('about-smallest-details') !== -1) {
      return false;
    }

    var peek = document.createElement('div');
    peek.className = 'about361-peek';
    peek.setAttribute('data-about-carousel-section', '');
    peek.setAttribute('data-about-layout', 'peek');
    peek.innerHTML = peekHtml;

    if (existing && existing._aboutSwiper) {
      try {
        existing._aboutSwiper.destroy(true, true);
      } catch (e) {}
    }

    section.className = 'about361 about-chapter about-chapter--peek-only about361--tight-top about361--tight-bottom';
    section.id = section.id || 'trustByTesting';
    section.removeAttribute('data-about-layout');
    section.innerHTML = '';
    section.appendChild(peek);
    return true;
  }

  function upgradeClosingCarouselToPeek() {
    var section =
      document.getElementById('aboutCarousel3') ||
      Array.prototype.find.call(document.querySelectorAll('.about361-carousel, .about-chapter--peek-only'), function (el) {
        return (
          (el.textContent || '').indexOf('كل صباح تبدأه براحة') !== -1 ||
          (el.innerHTML || '').indexOf('about-sunset-bedroom') !== -1 ||
          (el.innerHTML || '').indexOf('about-closing-morning') !== -1
        );
      });

    if (!section) return false;

    var existing = section.querySelector('.about361-peek');
    if (existing && (existing.innerHTML || '').indexOf('about-closing-morning') !== -1) {
      return false;
    }

    var peek = document.createElement('div');
    peek.className = 'about361-peek';
    peek.setAttribute('data-about-carousel-section', '');
    peek.setAttribute('data-about-layout', 'peek');
    peek.innerHTML =
      '<div class="about361-peek__wrap">' +
      '<div class="swiper about361-peek__swiper" dir="ltr">' +
      '<div class="swiper-wrapper">' +
      buildPeekSlide(
        'about-closing-morning.png',
        'غرفة نوم هادئة مع إطلالة هادئة عند الصباح',
        'كل صباح تبدأه براحة... يؤكد أننا نسير في الطريق الصحيح.',
        true
      ) +
      buildPeekSlide(
        'about-closing-journey.png',
        'رحلة نوم هادئ ليلة بعد ليلة',
        'نومك ليس محطة نصل إليها ونتوقف... بل رحلة نسير بها معك، ليلة بعد ليلة، نحو نومٍ هانئ.',
        false
      ) +
      '</div></div></div>';

    if (existing && existing._aboutSwiper) {
      try {
        existing._aboutSwiper.destroy(true, true);
      } catch (e) {}
    }

    section.className = 'about361 about-chapter about-chapter--peek-only about361--tight-top about361--tight-bottom';
    section.id = section.id || 'aboutCarousel3';
    section.removeAttribute('data-about-layout');
    section.innerHTML = '';
    section.appendChild(peek);
    return true;
  }

  function ensureHowWeStartedCopy() {
    var section = document.getElementById('howWeStarted');
    if (!section) return false;

    var head = section.querySelector('.about361__head');
    if (!head) {
      var shell = document.createElement('div');
      shell.className = 'page361 about361__shell';
      head = document.createElement('div');
      head.className = 'about361__head';
      head.setAttribute('data-reveal-group', '');
      shell.appendChild(head);
      section.insertBefore(shell, section.firstChild);
    }

    if (!section.querySelector('.about361__title')) {
      var title = document.createElement('h2');
      title.className = 'about361__title';
      title.setAttribute('data-reveal', '');
      title.textContent = 'كيف بدأنا؟';
      var icon = head.querySelector('.about361__icon-wrap');
      if (icon && icon.nextSibling) head.insertBefore(title, icon.nextSibling);
      else head.appendChild(title);
    }

    if (section.querySelector('.about361__body')) return false;

    var body = document.createElement('div');
    body.className = 'about361__body';
    body.setAttribute('data-reveal', '');
    body.innerHTML =
      '<p>من ملاحظة عابرة إلى التزام واضح</p>' +
      '<p>361 براند سعودي بالكامل، قرر منذ البداية ألا يكرر ما هو موجود في الســــوق، بل أن يبني كل منتج على أساس مدروس فعليًا: بإشراف أطبــــــاء مختصين، ودراسة حقيقية لكل نمط نوم قبل أن يتحول لتصميم نهائي..</p>' +
      '<p>وهكذا خرجت أولى منتجاتنا لتخدم حالات محددة بدقة، لا افتراضات عامة: من يتقلب كثيرًا أثـــــناء الليل، من يحتاج دعمًا أوضح لرقبته، ومن يبحث عن راحة فاخرة تشبه ما يجده في أرقى الفــنادق..</p>' +
      '<p>ومع كل منــــتج جديد، اتسعت مجموعتنا لتغطي احتياجات نوم مختلفة، لا لتكرر ما سبق إنجـــــازه..</p>';
    head.appendChild(body);
    return true;
  }

  function upgradeBehindDesignIcon() {
    var section = document.getElementById('behindEveryDesign');
    if (!section) {
      section = Array.prototype.find.call(document.querySelectorAll('.about-chapter'), function (el) {
        return (el.textContent || '').indexOf('ما وراء كل تصميم') !== -1;
      });
    }
    if (!section) return false;

    var icon = section.querySelector('.about361__icon-img');
    var iconWrap = section.querySelector('.about361__icon-wrap');
    if (icon && (icon.getAttribute('src') || '').indexOf('about-behind-design-icon-v2.png') === -1) {
      icon.setAttribute('src', assetUrlFromSibling('about-behind-design-icon-v2.png'));
      return true;
    }
    if (iconWrap && !icon) {
      iconWrap.innerHTML =
        '<img class="about361__icon-img" src="' +
        assetUrlFromSibling('about-behind-design-icon-v2.png') +
        '" width="218" height="219" alt="" loading="lazy" decoding="async">';
      return true;
    }
    return false;
  }

  function upgradeHowWeStartedIcon() {
    var section = document.getElementById('howWeStarted');
    if (!section) return false;

    var icon = section.querySelector('.about361__icon-img');
    var iconWrap = section.querySelector('.about361__icon-wrap');
    if (icon && (icon.getAttribute('src') || '').indexOf('about-how-we-started-title-icon.png') === -1) {
      icon.setAttribute('src', assetUrlFromSibling('about-how-we-started-title-icon.png'));
      return true;
    }
    if (iconWrap && !icon) {
      iconWrap.innerHTML =
        '<img class="about361__icon-img" src="' +
        assetUrlFromSibling('about-how-we-started-title-icon.png') +
        '" width="218" height="219" alt="" loading="lazy" decoding="async">';
      return true;
    }
    return false;
  }

  function upgradeQisatunaLeadNormal() {
    var section = document.getElementById('aboutIntro');
    if (!section) return false;
    var body = section.querySelector('.about361__body');
    if (!body) return false;
    var first = body.querySelector('p');
    if (!first) return false;
    if ((first.textContent || '').indexOf('كل شيء بدأ من نمط') === -1) return false;
    var strong = first.querySelector('strong');
    if (!strong) return false;
    first.innerHTML = strong.innerHTML;
    return true;
  }

  function upgradeManNahnuBadge() {
    var section = document.getElementById('aboutIntro');
    if (!section) return false;
    var badge = section.querySelector('.about361__badge');
    if (!badge) return false;

    badge.classList.add('about361__badge--dark');

    var iconWrap = badge.querySelector('.about361__badge-icon');
    if (!iconWrap) return true;

    var img = iconWrap.querySelector('img');
    if (img && (img.getAttribute('src') || '').indexOf('about-man-nahnu-badge-icon.png') !== -1) {
      return true;
    }

    iconWrap.innerHTML =
      '<img src="' +
      assetUrlFromSibling('about-man-nahnu-badge-icon.png') +
      '" width="53" height="52" alt="" loading="eager" decoding="async">';
    return true;
  }

  function upgradeQisatunaIcon() {
    var section = document.getElementById('aboutIntro');
    if (!section) return false;
    var icon = section.querySelector('.about361__icon-img');
    if (!icon) return false;
    if ((icon.getAttribute('src') || '').indexOf('about-qisatuna-title-icon.png') !== -1) {
      return false;
    }
    icon.setAttribute('src', assetUrlFromSibling('about-qisatuna-title-icon.png'));
    return true;
  }

  function removeAboutDots() {
    document.querySelectorAll('.about361__dots').forEach(function (el) {
      el.remove();
    });
  }

  function boot() {
    removeAboutDots();
    upgradeManNahnuBadge();
    upgradeQisatunaIcon();
    upgradeQisatunaLeadNormal();
    upgradeHowWeStartedIcon();
    upgradeBehindDesignIcon();
    upgradeLegacyHowCard();
    ensureHowWeStartedCopy();
    upgradeNoOneSolutionBand();
    upgradePromisesBannerSingle();
    upgradeNoOneSolutionSingle();
    upgradeComfortToPair();
    upgradeInsetPairPanel();
    upgradeNeedPairImages();
    upgradeJourneyPanelImage();
    upgradeTrustPeek();
    upgradeClosingCarouselToPeek();

    whenSwiper(function (Swiper) {
      document.querySelectorAll('[data-about-carousel-section]').forEach(function (root) {
        if (root._aboutSwiper) return;
        initCarousel(root, Swiper);
      });
      removeAboutDots();
    });
  }

  ready(boot);

  document.addEventListener('shopify:section:load', function (event) {
    var scope = event.target;
    if (!scope) return;

    var roots = [];
    if (scope.matches && scope.matches('[data-about-carousel-section]')) {
      roots.push(scope);
    }
    if (scope.querySelectorAll) {
      scope.querySelectorAll('[data-about-carousel-section]').forEach(function (el) {
        roots.push(el);
      });
    }

    roots.forEach(function (root) {
      if (root._aboutSwiper) {
        root._aboutSwiper.destroy(true, true);
        root._aboutSwiper = null;
      }
    });

    boot();
  });
})();
